import React from 'react';
import './Laboratory.css';
import labImg from './assets/lab.jpg';
import img1 from './assets/lab.jpg';
import img2 from './assets/lab2.jpg';
import img3 from './assets/lab3.jpg';

const Laboratory = () => {
  return (
    <div className="laboratory-page">
      {/* Hero Image Section */}
      <section className="hero-section">
        <div className="hero-image-wrapper">
          <img src={labImg} alt="Laboratory" className="hero-image" />
          <div className="overlay-text">
            <h1>Welcome to Our Laboratory</h1>
            <p>Here, science meets precision. Our lab is equipped to ensure accurate, reliable results for informed care.</p>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="video-section">
        <h2>🎥 Meet Our Lab Technologist</h2>
        <p className="video-caption">
          Learn what happens during your lab visit and how your samples are handled with care.
        </p>
        <div className="video-wrapper">
          <video
            controls
            playsInline
            preload="metadata"
            className="lab-video"
          >
            <source
              src="https://res.cloudinary.com/dfbgpqygq/video/upload/v1751526828/InShot_20250703_095351587_1_p3s4df.mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>


<div className="red-divider"></div>


      {/* Three Image Highlights */}
      <section className="image-showcase">
        <div className="image-box">
          <img src={img1} alt="Sample Collection" />
          <h3>Laboratory</h3>
          <p>Well-equipped lab for timely and accurate diagnostic testing, featuring modern technology machines such as Cobas C111 and Electrolyte Analyzer.</p>
        </div>
        <div className="image-box">
          <img src={img2} alt="Blood Analysis" />
          <h3>Cobas c111 Machine</h3>
          <p>A compact and accurate clinical chemistry analyzer that measures key health markers like blood glucose, liver enzymes, and kidney function. Its automation ensures fast, reliable results, making it ideal for routine diagnostics at Mwangaza.</p>
        </div>
        <div className="image-box">
          <img src={img3} alt="Results Processing" />
          <h3>Electrolyte Analyzer</h3>
          <p>It provides rapid, accurate measurements of vital electrolytes—sodium, potassium, chloride, and bicarbonate—helping assess hydration, kidney function, and acid-base balance. It plays a key role in both routine and emergency diagnostics at Mwangaza.</p>
        </div>
      </section>

      <div className="red-divider"></div>

      {/* FAQs */}
      <section className="faq-section">
        <h2>🧠 Frequently Asked Questions (FAQs)</h2>
        <ul className="faq-list">
          <li>
            <span className="faq-question">How do I prepare for lab tests?</span><br />
            <span className="faq-answer">Some tests require fasting. Our team will advise based on your appointment.</span>
          </li>
          <li>
            <span className="faq-question">How soon are results ready?</span><br />
            <span className="faq-answer">Most results are available within 24 hours.</span>
          </li>
          <li>
            <span className="faq-question">Is the lab safe and sterile?</span><br />
            <span className="faq-answer">Yes. Our laboratory follows strict infection prevention protocols.</span>
          </li>
          <li>
            <span className="faq-question">Do I need a doctor’s order?</span><br />
            <span className="faq-answer">Yes, unless advised during our screening process. All lab tests must be medically necessary.</span>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default Laboratory;
